(() => {
  if (customElements.get('fc-pro')) return;
class FeaturedCollectionPro extends HTMLElement {
  constructor() {
    (super(),
      (this.panels = []),
      (this.tabs = []),
      (this.activeIndex = 0),
      (this.reduceMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)",
      ).matches),
      (this.onTabClick = this.onTabClick.bind(this)),
      (this.onTabKeydown = this.onTabKeydown.bind(this)),
      (this.onBreakpoint = this.onBreakpoint.bind(this)));
  }
  connectedCallback() {
    ((this.root = this.closest(".fc-pro") || this),
      (this.tabList = this.root.querySelector(".fc-pro__tabs")),
      (this.tabs = Array.from(this.root.querySelectorAll(".fc-pro__tab"))),
      (this.indicator = this.root.querySelector(".fc-pro__tab-indicator")),
      (this.viewAllLinks = Array.from(
        this.root.querySelectorAll("[data-view-all]"),
      )),
      (this.loop = "true" === this.dataset.loop),
      (this.scrollByPage = "one" !== this.dataset.scrollBy),
      (this.panels = Array.from(this.querySelectorAll(".fc-pro__panel")).map(
        (t) => ({
          el: t,
          viewport: t.querySelector("[data-viewport]"),
          track: t.querySelector("[data-track]"),
          slides: Array.from(t.querySelectorAll("[data-slide]")),
          prev: t.querySelector("[data-prev]"),
          next: t.querySelector("[data-next]"),
          dots: t.querySelector("[data-dots]"),
          progressBar: t.querySelector("[data-progress-bar]"),
          collectionUrl: t.dataset.collectionUrl || "",
          embla: null,
          armed: !1,
        }),
      )),
      0 !== this.panels.length &&
        (this.tabs.forEach((t) => {
          (t.addEventListener("click", this.onTabClick),
            t.addEventListener("keydown", this.onTabKeydown));
        }),
        (this.mqs = ["(min-width: 750px)", "(min-width: 990px)"].map((t) => {
          const e = window.matchMedia(t);
          return (
            e.addEventListener
              ? e.addEventListener("change", this.onBreakpoint)
              : e.addListener && e.addListener(this.onBreakpoint),
            e
          );
        })),
        this.activatePanel(0, { initial: !0 }),
        this.positionIndicator(!1),
        requestAnimationFrame(
          () => this.tabList && this.tabList.classList.add("is-ready"),
        )));
  }
  disconnectedCallback() {
    (this.panels.forEach((t) => {
      t.embla && (t.embla.destroy(), (t.embla = null));
    }),
      this.tabs.forEach((t) => {
        (t.removeEventListener("click", this.onTabClick),
          t.removeEventListener("keydown", this.onTabKeydown));
      }),
      (this.mqs || []).forEach((t) => {
        t.removeEventListener
          ? t.removeEventListener("change", this.onBreakpoint)
          : t.removeListener && t.removeListener(this.onBreakpoint);
      }),
      this.indicatorFrame && cancelAnimationFrame(this.indicatorFrame));
  }
  onTabClick(t) {
    const e = parseInt(t.currentTarget.dataset.index, 10);
    Number.isNaN(e) || this.selectTab(e, { focus: !1 });
  }
  onTabKeydown(t) {
    const e = "rtl" === getComputedStyle(this.root).direction ? -1 : 1,
      s = this.tabs.length - 1,
      i = parseInt(t.currentTarget.dataset.index, 10) || 0;
    let r = null;
    switch (t.key) {
      case "ArrowRight":
        r = i + e;
        break;
      case "ArrowLeft":
        r = i - e;
        break;
      case "Home":
        r = 0;
        break;
      case "End":
        r = s;
        break;
      default:
        return;
    }
    null !== r &&
      (t.preventDefault(),
      r < 0 && (r = s),
      r > s && (r = 0),
      this.selectTab(r, { focus: !0 }));
  }
  selectTab(t, { focus: e = !1 } = {}) {
    if (t === this.activeIndex || !this.panels[t]) return;
    const s = this.tabs[this.activeIndex];
    s &&
      (s.classList.remove("is-active"),
      s.setAttribute("aria-selected", "false"),
      (s.tabIndex = -1));
    const i = this.tabs[t];
    (i &&
      (i.classList.add("is-active"),
      i.setAttribute("aria-selected", "true"),
      (i.tabIndex = 0),
      e && i.focus(),
      this.scrollTabIntoView(i)),
      (this.panels[this.activeIndex].el.hidden = !0),
      (this.activeIndex = t),
      this.activatePanel(t),
      this.positionIndicator(!0));
    const r = this.panels[t].collectionUrl;
    r &&
      this.viewAllLinks.forEach((t) => {
        t.href = r;
      });
  }
  scrollTabIntoView(t) {
    const e = this.tabList;
    if (!e || e.scrollWidth <= e.clientWidth + 1) return;
    const s = e.getBoundingClientRect(),
      i = t.getBoundingClientRect(),
      r = i.left - s.left - (s.width - i.width) / 2;
    if (Math.abs(r) < 2) return;
    const a = this.reduceMotion ? "auto" : "smooth";
    e.scrollTo
      ? e.scrollTo({ left: e.scrollLeft + r, behavior: a })
      : (e.scrollLeft += r);
  }
  positionIndicator(t) {
    if (!this.indicator || !this.tabList) return;
    const e = this.tabs[this.activeIndex];
    e &&
      (this.indicatorFrame && cancelAnimationFrame(this.indicatorFrame),
      (this.indicatorFrame = requestAnimationFrame(() => {
        ((this.indicatorFrame = null),
          t || (this.indicator.style.transition = "none"),
          this.indicator.style.setProperty(
            "--fc-ind-x",
            e.offsetLeft - this.tabList.scrollLeft + "px",
          ),
          this.indicator.style.setProperty("--fc-ind-w", `${e.offsetWidth}px`),
          t ||
            (this.indicator.offsetWidth,
            (this.indicator.style.transition = "")));
      })));
  }
  wantsCarousel() {
    /* ============================================================
       matchMedia مش window.innerWidth — وده مش تفضيل، ده تصليح باج.

       window.innerWidth بيحسب **مع** شريط التمرير، والميديا كويري
       في CSS بتحسب من غيره (فرق ~15px في كروم). فعند حدود الـ 990
       الاتنين كانوا بيختلفوا: الجافاسكريبت يقول ديسكتوب والـ CSS
       يقول موبايل.

       والأوحش إن وجود شريط التمرير نفسه بيعتمد على طول الصفحة، وطول
       الصفحة بيتغيّر وإحنا بنحمّل الصور الكسولة — فالنتيجة كانت
       بتختلف من ريفريش للتاني: مرة كاروسيل ومرة جريد.

       بـ matchMedia الاتنين بيقيسوا بنفس الطريقة بالظبط فمستحيل
       يختلفوا.
       ============================================================ */
    const isDesktop = window.matchMedia("(min-width: 990px)").matches;
    return (
      "grid" !==
      (isDesktop ? this.dataset.layoutDesktop : this.dataset.layoutMobile)
    );
  }
  activatePanel(t, { initial: e = !1 } = {}) {
    const s = this.panels[t];
    s &&
      ((s.el.hidden = !1),
      this.wantsCarousel()
        ? (s.el.classList.remove("is-grid"), this.initCarousel(s))
        : (s.el.classList.add("is-grid"), this.destroyCarousel(s)));
  }
  initCarousel(t) {
    if (t.embla || !t.viewport || t.slides.length < 2) return;
    const e = window.EmblaCarousel;
    if ("function" != typeof e) {
      /* الرجوع للجريد هنا **مؤقت** مش نهائي. لو المكتبة اتأخرت لأي
         سبب (كاش بايظ، نت بطيء، سكربت اتأجّل)، كان السكشن بيفضل جريد
         للأبد. دلوقتي بيحاول تاني بعد ما الصفحة تخلّص تحميل. */
      t.el.classList.add("is-grid");
      if (!t.retryBound) {
        t.retryBound = !0;
        window.addEventListener(
          "load",
          () => {
            if (typeof window.EmblaCarousel === "function" && this.wantsCarousel()) {
              t.el.classList.remove("is-grid");
              this.initCarousel(t);
            }
          },
          { once: !0 },
        );
      }
      if (window.__FC_PRO_DEBUG)
        console.warn("[fc-pro] embla-carousel.umd.js مش محمّل — هيحاول تاني بعد الـ load.");
      return;
    }
    try {
      t.embla = e(t.viewport, {
        container: t.track,
        slides: t.slides,
        align: this.dataset.align === "center" ? "center" : "start",
        /* مع المحاذاة الوسطية لازم يتلغي: trimSnaps بيقفل أول وآخر
           شريحة على حافة الإطار، وده بيمنع الحتة من الجنبين اللي هي
           كل فكرة الوضع ده. */
        containScroll: this.loop
          ? void 0
          : this.dataset.align === "center"
            ? false
            : "trimSnaps",
        loop: this.loop,
        slidesToScroll: this.scrollByPage ? "auto" : 1,
        dragFree: !1,
        /* ============================================================
           فلِكة قوية لازم تعدّي أكتر من نقطة توقف واحدة.

           مع skipSnaps: false إمبلا بترجّع أي سحبة — مهما كانت سريعة —
           لنقطة التوقف **اللي جنبها على طول**. والسكشن ده متظبّط
           "صف كامل في المرة" (slidesToScroll: auto)، يعني نقطة التوقف
           الواحدة = كارتين أو تلاتة. فالنتيجة إنك بتفلِك بقوة والصف
           بيزحف مسافة طويلة بحركة واحدة بطيئة — وده بالظبط الإحساس
           بإن الكاروسيل "تقيل".

           بـ true السرعة بتتحوّل لمسافة زي أي سكرول طبيعي.
           ============================================================ */
        skipSnaps: !0,
        direction:
          "rtl" === getComputedStyle(this.root).direction ? "rtl" : "ltr",
        duration: this.reduceMotion ? 0 : 22,
      });
      const s = () => this.syncNav(t);
      /* ============================================================
         حدث scroll بيولع مع **كل فريم** من السحب. اللي كان متربط بيه
         هو syncNav بالكامل: لفة على كل النقط بـ classList.toggle
         و setAttribute، وكتابة disabled على السهمين، وخاصيتين inline
         على شريط التقدّم — كل ده، كل فريم، وإحنا بنسحب.

         و setAttribute تحديدًا مش رخيصة: بتبطّل حساب ستايل العنصر
         وبتدفع تحديث لشجرة الوصولية كل مرة. على الديسكتوب ده بيختفي
         في الضوضاء؛ على الموبايل بيتحوّل لتهتهة في نص السحبة.

         الحاجة الوحيدة اللي **محتاجة** كل فريم فعلاً هي عرض شريط
         التقدّم. النقط والسهمين بيتغيّروا لما نقطة التوقف تتغيّر بس —
         يعني على select. فالاتنين اتفصلوا.

         وكمان: الاشتراك في scroll أصلاً بيحصل لو فيه شريط تقدّم
         **ظاهر**. في وضع nav-none (وهو وضع كل سكشنات الصفحة الرئيسية
         دلوقتي) الشريط مخفي بـ display:none، فالشغل ده كان بيتعمل كل
         فريم على عناصر مش باينة خالص.
         ============================================================ */
      const prog = () => this.syncProgress(t);
      t.hasProgress = !!(t.progressBar && null !== t.progressBar.offsetParent);

      /* ============================================================
         تلميحة للمتصفح إنه يرفع المسار لطبقة خاصة بيه وهو بيتحرك بس.

         إمبلا بتكتب translate3d، بس ده لوحده مبقاش بيضمن ترقية لطبقة
         في كروم الحديث — فكل فريم كان ممكن يعيد رسم الكروت الجوّه.
         will-change بيضمنها، وبيتشال بعد ما الحركة تستقر عشان
         مناخدش الذاكرة على الفاضي.
         ============================================================ */
      const drop = () => {
        (t.wcTimer && (clearTimeout(t.wcTimer), (t.wcTimer = null)),
          t.track && (t.track.style.willChange = ""));
      };
      /* المؤقت شبكة أمان: settle بيتنده من لوب الأنيميشن، ولو الحركة
         اتقطعت (تاب اتخبّى في نص السحبة مثلاً) الحدث ممكن ميجيش خالص
         والطبقة تفضل محجوزة على الفاضي. */
      const lift = () => {
        (t.track && (t.track.style.willChange = "transform"),
          t.wcTimer && clearTimeout(t.wcTimer),
          (t.wcTimer = setTimeout(drop, 1200)));
      };
      (t.hasProgress && t.embla.on("scroll", prog),
        t.embla.on("pointerDown", lift),
        t.embla.on("settle", drop),
        t.embla.on("select", s),
        // reInit بيحصل لما المقاس يتغيّر (لفّ الموبايل / تغيير بريكبوينت)،
        // وساعتها عدد نقط التوقف بيتغيّر كمان. syncNav لوحدها بتحدّث النقط
        // الموجودة بس — فلازم يتعاد بناؤها بالعدد الجديد.
        t.embla.on("reInit", () => {
          ((t.lastProgress = null), this.buildDots(t), s());
        }),
        this.buildDots(t),
        s(),
        t.prev &&
          (t.prev.onclick = () => {
            t.embla && (lift(), t.embla.scrollPrev());
          }),
        t.next &&
          (t.next.onclick = () => {
            t.embla && (lift(), t.embla.scrollNext());
          }));
    } catch (e) {
      (window.__FC_PRO_DEBUG && console.error("[fc-pro] فشل تشغيل Embla:", e),
        (t.embla = null),
        t.el.classList.add("is-grid"));
    }
  }
  destroyCarousel(t) {
    (t.wcTimer && (clearTimeout(t.wcTimer), (t.wcTimer = null)),
      t.track && (t.track.style.willChange = ""));
    t.embla &&
      (t.embla.destroy(),
      (t.embla = null),
      t.dots && ((t.dots.innerHTML = ""), t.dots.classList.remove("is-ready")));
  }
  buildDots(t) {
    if (!t.dots || !t.embla) return;
    const e = t.embla.scrollSnapList().length;
    /* النقط بتتبني من أول وجديد هنا، فالفهرس المخزّن بتاع آخر نقطة
       نشطة بقى بيشاور على عنصر مابقاش موجود. */
    t.lastDot = -1;
    /* الماركب بيقول role="tablist" بس دول مش تابات — مفيش tabpanel
       ورا كل واحدة. tablist بأولاد مش تابات بيتقري كقائمة تابات
       فاضية، وده أوحش من إننا منقولش حاجة. المحرك ده هو اللي بيبني
       كل الأولاد، فبيصلّح الدور من هنا لكل السكشنات مرة واحدة. */
    t.dots.setAttribute("role", "group");
    /* بتتصفّر هنا مش جوّه الشرط: نقطة توقف واحدة معناها مفيش نقط
       خالص، والقايمة القديمة كانت هتفضل مشاورة على أزرار اتشالت. */
    t.dotEls = [];
    if (((t.dots.innerHTML = ""), !(e < 2))) {
      for (let s = 0; s < e; s += 1) {
        const e = document.createElement("button");
        ((e.type = "button"),
          (e.className = "fc-pro__dot"),
          e.setAttribute("aria-label", `${s + 1}`),
          e.addEventListener("click", () => t.embla && t.embla.scrollTo(s)),
          t.dots.appendChild(e),
          t.dotEls.push(e));
      }
      t.dots.classList.add("is-ready");
    }
  }
  /* بتتنده كل فريم وقت السحب — فمفيهاش غير شغل الشريط، ومن غير أي
     كتابة على الـ DOM لو القيمة ماتحرّكتش بعد التقريب. */
  syncProgress(t) {
    if (!t.embla || !t.progressBar) return;
    const e = t.embla.scrollSnapList().length;
    if (!e) return;
    /* ============================================================
       الشريط بيتملي من البداية للنهاية بدل ما يبقى قطعة صغيرة
       بتتزحلق. القطعة المتحركة كانت بتقرا كشريط تمرير مش كتقدّم.

       scrollProgress بترجع 0..1 على طول السحب، فالشريط بيتحرك مع
       الإصبع مش بيقفز بين النقط. والمعادلة بتخلي أول شريحة تبان
       1/العدد مليانة بدل صفر — شريط فاضي تمامًا شكله غلط.
       ============================================================ */
    const s = e <= 1 ? 1 : (t.embla.scrollProgress() * (e - 1) + 1) / e,
      i = Math.min(100, Math.max(0, 100 * s)),
      r = Math.round(10 * i) / 10;
    /* كل كتابة inline style بتبطّل حساب ستايل العنصر. فرق أقل من
       عُشر بالمية مش بيبان على شريط عرضه 24rem، فمبيستاهلش. */
    t.lastProgress !== r &&
      ((t.lastProgress = r),
      t.progressBar.style.setProperty("--fc-progress-w", r + "%"));
  }
  /* بتتنده لما نقطة التوقف تتغيّر بس — مش كل فريم. */
  syncNav(t) {
    if (!t.embla) return;
    const e = t.embla.selectedScrollSnap();
    if (
      (t.prev && (t.prev.disabled = !t.embla.canScrollPrev()),
      t.next && (t.next.disabled = !t.embla.canScrollNext()),
      t.dotEls && t.lastDot !== e)
    ) {
      const s = t.dotEls;
      for (let i = 0; i < s.length; i += 1) {
        const r = i === e;
        (s[i].classList.toggle("is-active", r),
          s[i].setAttribute("aria-current", r ? "true" : "false"));
      }
      t.lastDot = e;
    }
    this.syncProgress(t);
  }
  onBreakpoint() {
    const t = this.wantsCarousel();
    (this.panels.forEach((e, s) => {
      s === this.activeIndex
        ? t
          ? (e.el.classList.remove("is-grid"),
            e.embla ? e.embla.reInit() : this.initCarousel(e))
          : (e.el.classList.add("is-grid"), this.destroyCarousel(e))
        : this.destroyCarousel(e);
    }),
      this.positionIndicator(!1));
  }
}
customElements.define("fc-pro", FeaturedCollectionPro);

/* ============================================================
   كشف عنوان السكشن وزراره عند السكرول.

   مكتوب كوحدة مستقلة على مستوى الدوكيومنت مش جوّه <fc-pro> عن قصد:
   العنوان **بره** العنصر المخصص (أخ له جوّه .fc-pro)، وكمان كده
   أي سكشن تاني يحط data-head-reveal بياخد نفس الحركة.

   بيحترم تقليل الحركة، وبيتوقف عن المراقبة بعد أول ظهور.
   ============================================================ */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
  );

  function scan(root) {
    (root || document).querySelectorAll('[data-head-reveal]').forEach(function (el) {
      if (el.dataset.headRevealBound) return;
      el.dataset.headRevealBound = '1';
      el.classList.add('fc-pro__head--reveal');
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

})();
